import { IntlShape } from "react-intl";
import Swal from "sweetalert2";
import * as yup from "yup";
import { ICommunicationType } from "../../interfaces/Correspondence";
import { optionsCommunicationType as communicationTypes } from "../../shared/constants/communicationTypes";

export interface params {
  nit: string;
}

export interface PqrsFormData {
  name: string;
  identificationNumber: string;
  phone: string;
  email: string;
  emailConfirm: string;
  address: string;
  country: string;
  department: string;
  city: string;
  communicationType: string;
  description: string;
  receiveEmail: boolean;
  privacyPolicy: boolean;
}

export const defaultCorrespondenceType = "ER";
export const defaultStatus = "InProcess";
export const defaultInternalStatus = "Unanswered";

export const optionsCommunicationType: ICommunicationType[] =
  communicationTypes.filter((option) => option.isParam);

export const initialData = {
  name: "",
  identificationNumber: "",
  phone: "",
  email: "",
  emailConfirm: "",
  address: "",
  country: "",
  department: "",
  city: "",
  communicationType: "",
  description: "",
  receiveEmail: false,
  privacyPolicy: false,
};

export const someValidationSchema = (intl: IntlShape) =>
  yup.object({
    name: yup.string(),
    identificationNumber: yup.number(),
    phone: yup.number().typeError(intl.formatMessage({ id: "NumericField" })),
    email: yup.string().email(intl.formatMessage({ id: "EmailNotValid" })),
    emailConfirm: yup
      .string()
      .email(intl.formatMessage({ id: "EmailNotValid" }))
      .oneOf(
        [yup.ref("email"), null],
        intl.formatMessage({ id: "EmailNotMatch" })
      ),
    address: yup.string(),
    country: yup.string(),
    department: yup.string(),
    city: yup.string(),
    communicationType: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    description: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),

    privacyPolicy: yup
      .boolean()
      .isTrue(intl.formatMessage({ id: "ShouldAcceptPolicy" })),
  });

export const allRequiredValidationSchema = (intl: IntlShape) =>
  yup.object({
    name: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    identificationNumber: yup
      .number()
      .typeError("Campo numérico")
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    phone: yup
      .number()
      .typeError("Campo numérico")
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    email: yup
      .string()
      .email(intl.formatMessage({ id: "EmailNotValid" }))
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    emailConfirm: yup
      .string()
      .oneOf(
        [yup.ref("email"), null],
        intl.formatMessage({ id: "EmailNotMatch" })
      )
      .email(intl.formatMessage({ id: "EmailNotValid" }))
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    address: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    country: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    department: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    city: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    communicationType: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    description: yup
      .string()
      .required(`${intl.formatMessage({ id: "RequiredFile" })}`),
    privacyPolicy: yup
      .boolean()
      .isTrue(intl.formatMessage({ id: "ShouldAcceptPolicy" })),
  });

export const showMessage = (isOk: boolean, intl: IntlShape) => {
  Swal.fire({
    title: isOk
      ? intl.formatMessage({ id: "SuccessfulRegistrationTitle" })
      : intl.formatMessage({ id: "ErrorRegistrationTitle" }),
    icon: isOk ? "success" : "error",
    text: isOk
      ? intl.formatMessage({ id: "PqrsSuccessfullyBody" })
      : intl.formatMessage({ id: "PqrsErrorBody" }),
    showConfirmButton: true,
    confirmButtonText: intl.formatMessage({ id: "Accept" }),
    confirmButtonColor: "#3f51b5",
    customClass: {
      container: "swal-container-z-index",
    },
  }).then(() => {
    if (isOk) {
      window.location.reload();
    }
  });
};
